import {createSelector} from 'reselect';
import FEATURE_FLAGS from '../../utils/featureFlags';

const gsConfigSelector = (state) => state && state.gsConfig || {};

const selectWebTLD = ((state) => state?.gsConfig?.defaultWebTLD || 'com');

const selectCurrentLocale = ((state) => state?.gsConfig?.currentLocale || 'en-US');

const selectSHstoreId = ((state) => state?.gsConfig?.shstoreId || 1);

const showHyperWalletAddPaymentMethodWarning = ((state) => state?.gsConfig?.features?.[FEATURE_FLAGS.sell.hyperwallet.showAddPaymentMethodWarning] || false);

const selectOriginCountryCode = ((state) => state?.gsConfig?.supportedCountries[0] || 'US');

const selectCurrency = ((state) => state?.gsConfig?.defaultCurrency || 'USD');

const featureFlagsSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.features || {});

const storeIdSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.shstoreId);

const currentLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.currentLocale);

const defaultWebTLDSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.defaultWebTLD);

const defaultLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.defaultLocale);

export {
  gsConfigSelector,
  selectWebTLD,
  selectCurrentLocale,
  selectSHstoreId,
  showHyperWalletAddPaymentMethodWarning,
  selectOriginCountryCode,
  selectCurrency,
  featureFlagsSelector,
  storeIdSelector,
  currentLocaleSelector,
  defaultLocaleSelector,
  defaultWebTLDSelector
};
